import { useState } from 'react';

export const useTheme = () => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('mygoal-theme');
    return saved ? saved === 'dark' : true;
  });
  
  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    localStorage.setItem('mygoal-theme', newTheme ? 'dark' : 'light');
  };
  
  return { isDark, toggleTheme };
};

export const useThemeClasses = (isDark) => ({
  bg: isDark ? 'bg-[#0a0a0f]' : 'bg-gradient-to-br from-[#f8f7ff] via-[#f0eeff] to-[#e8e4ff]',
  card: isDark ? 'bg-[#1a1a2e]/80 border-white/10' : 'bg-white/80 border-[#493986]/10 shadow-lg',
  textPrimary: isDark ? 'text-white' : 'text-[#493986]',
  textSecondary: isDark ? 'text-white/60' : 'text-[#493986]/60',
  textMuted: isDark ? 'text-white/50' : 'text-[#493986]/50',
  input: isDark ? 'bg-white/5 border-white/10 text-white placeholder-white/30' : 'bg-white border-[#493986]/20 text-[#493986] placeholder-[#493986]/30',
  button: isDark ? 'bg-white/5 hover:bg-white/10' : 'bg-[#493986]/5 hover:bg-[#493986]/10',
});

export default useTheme;
